import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
export const TextFieldOne: React.FC<TextFieldProps> = (props) => {
  return (
    <TextField
      size={'small'}
      sx={{
        fontSize: '1rem',
        fontWeight: 400,
        '& .MuiInputLabel-root': {
          '&.Mui-focused': {
            color: '#3C419A !important',
          },
        },
        '& .MuiOutlinedInput-root': {
          '&.Mui-focused fieldset': {
            border: '1px solid #3C419A',
            color: ' #3C419A !important',
          },
          height: 40,
          width: 160,
          fontSize: '1rem',
          fontWeight: 400,
        },
        ...props.sx,
      }}
      {...props}
    />
  );
};
